import React from 'react';

import { useTrackingData } from './DataProviders';


function friendlyCarrierName(carrier) {
  switch ((carrier || '').toLowerCase()) {
    case 'usps':
      return 'USPS';
    case 'ups':
      return 'UPS';
    case 'fedex':
      return 'FedEx';
    default:
      return '';
  }
}


function friendlyMessageFromStatus({ source_status_code, carrier, estimated_delivery_date, carrier_events=[] }) {
  const IN_TRANSIT_MSG = 'Your shipment is on its way.';
  switch( (source_status_code || '').toUpperCase() ) {
    case 'AC':
      return 'Tracking details will be available once package arrives at the shipping facility.';
    case 'IT':
      return IN_TRANSIT_MSG;
    case 'DE':
      return 'Your shipment has been delivered.';
    case 'EX':
      return 'Your shipment status is unavailable. Check back later.';
    case 'UN':
      if( estimated_delivery_date || carrier_events.length ) {
        return IN_TRANSIT_MSG;
      }
      else {
        return 'Your shipment status is unknown. Check back later.';
      }
    case 'AT': {
      const carrierName = friendlyCarrierName(carrier);
      if (carrierName) {
        return `${carrierName} attempted to deliver your shipment. Contact ${carrierName} for more information.`;
      }

      return 'The carrier attempted to deliver your shipment. Contact the carrier for more information.';
    }
    default:
      return 'Tracking details will be available once package arrives at the shipping facility.';
  }
}


export default function FriendlyStatusMessage({ className }) {
  const trackingData = useTrackingData();

  if (!trackingData.source || trackingData.source.toLowerCase() !== 'shipengine') {
    return '';
  }

  const message = friendlyMessageFromStatus( trackingData );

  return <span className={className}>
    {message}
  </span>;
}